module.exports = vendor_5aee9fe60f2131e082e8;